var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loading-component',{attrs:{"theme":"internal"}}):_vm._e(),_vm._v(" "),(_vm.contact_form)?_c('contact-form',{attrs:{"acf-fields":_vm.contact_form,"email-replace":_vm.emailReplace,"field-replace":_vm.fieldsReplace}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }